export default "__VITE_ASSET__CLCjj5s$__"